import React, { useState } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import bgg from "assets/img/bgg.png";
import Select from "react-select";

export default function Enquiry() {
    const [currentStep, setCurrentStep] = useState(1);

    const handleNext = () => {
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleSubmit = () => {
        alert("Form submitted!");
    };

    const options13 = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "others", label: "Others" },
    ];

    const options14 = [
        { value: "Playgroup", label: "Playgroup" },
        { value: "nursery", label: "Nursery" },
        { value: "kindergarten 1 (LKG)", label: "Kindergarten 1 (LKG)" },
        { value: "kindergarten 2 (UKG)", label: "Kindergarten 2 (UKG)" },
    ];

    const options15 = [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
    ];

    const options16 = [
        { value: "SocialMedia", label: "SocialMedia" },
        { value: "Referral (Friend/Family)", label: "Referral (Friend/Family)" },
        { value: "Website", label: "Website" },
        { value: "Walk-in/Drive-by", label: "Walk-in/Drive-by" },
        { value: "Other", label: "Other" },
    ];

    return (
        <>
            <AdminNavbar fixed />
            <section className="">
                <div className=" xl:pt-32 xl:pb-16"
                    style={{
                        backgroundColor: '#f0f7fa',
                        backgroundImage: `url(${bgg})`,
                        backgroundPosition: "center center", // Correct property name
                        backgroundRepeat: "repeat", // No need to quote unless special characters
                        backgroundSize: "55% auto", // No dash in property names
                    }}>
                    <div className="container mx-auto">
                        <div className="xl:w-10/12 justify-center mx-auto text-center items-center">
                            <p className="text-peach xl:text-2xl bubblegum">
                                Junior Toes - Enquiry Form
                            </p>
                            <h2 className="xl:text-5xl font-bold text-black pt-2">
                                Enquiry Form
                            </h2>
                        </div>
                    </div>
                </div>



                <div className="bg-gray-100 xl:mb-12 xl:mt-32 rounded-lg xl:p-8 xl:w-7/12 justify-center mx-auto" style={{ border: '1px solid #e8e8e8' }}>

                    {currentStep === 1 &&
                        <>
                            <div className="xl:mt-8">
                                <h1 className="text-4xl text-black  font-bold  text-center ">
                                    Child's Information
                                </h1><p className="text-base pt-2 text-blue text-center">
                                    Please fill in all the required fields (marked with *)
                                </p>
                                <div className="xl:w-12/12 xl:mt-12">
                                    <div>
                                        <label class="text-black text-base" for="academic">
                                            Child's Full Name
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                    </div>
                                    <input
                                        className="w-full rounded borderform xl:mt-2"
                                        type="text"
                                        id="text"
                                        required />
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base " htmlFor="academic">
                                            Date of Birth
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2 xl:py-2 xl:px-2"
                                            type="date"
                                            id="text"
                                            required />
                                    </div>

                                    <div className="xl:w-6/12">
                                        <div>
                                            <label class="text-black text-base" for="academic">
                                                Age (in Years)
                                                <span class="required text-red-500"> *</span>
                                            </label>
                                        </div>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base" htmlFor="state">
                                            Gender
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <Select
                                            className="xl:w-full xl:mt-2"
                                            classNamePrefix="custom-select"
                                            options={options13}
                                            placeholder=""
                                            isSearchable={true}
                                            id="gender"
                                            name="gender"
                                            required />
                                    </div>

                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base" htmlFor="city">
                                            Admission Required for
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <Select
                                            className="xl:w-full xl:mt-2"
                                            classNamePrefix="custom-select"
                                            options={options14}
                                            placeholder=""
                                            isSearchable={true} // Enable search functionality
                                            id="Branch"
                                            name="Branch"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base" htmlFor="state">
                                            Preferred Start Date
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>

                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base" htmlFor="state">
                                            Distance from School (in kms)
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:w-12/12 xl:mt-8">
                                    <div>
                                        <label class="text-black text-base" for="academic">
                                            Address
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                    </div>
                                    <textarea
                                        className="w-full rounded borderform xl:mt-2"
                                        style={{ height: '100px' }}
                                        type="text"
                                        id="text"
                                        required />
                                </div>
                            </div>
                        </>
                    }
                    {currentStep === 2 &&
                        <>
                            <div className="xl:mt-8">
                                <h1 className="text-4xl text-black  font-bold  text-center ">
                                    Parent/Guardian Information
                                </h1><p className="text-base pt-2 text-blue text-center">
                                    Please fill in all the required fields (marked with *)
                                </p>

                                <div className="xl:mt-12 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label class="text-black text-base" for="academic">
                                            Father's Name
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                    <div className="xl:w-6/12">
                                        <label class="text-black text-base" for="academic">
                                            Educational Qualification
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base " htmlFor="academic">
                                            Occupation
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2 xl:px-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>

                                    <div className="xl:w-6/12">
                                        <div>
                                            <label class="text-black text-base" for="academic">
                                                Annual Income
                                                <span class="required text-red-500"> *</span>
                                            </label>
                                        </div>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base " htmlFor="academic">
                                            Contact Number
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2 xl:px-2"
                                            type="number"
                                            required />
                                    </div>

                                    <div className="xl:w-6/12">
                                        <div>
                                            <label class="text-black text-base" for="academic">
                                                Email Id
                                                <span class="required text-red-500"> *</span>
                                            </label>
                                        </div>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="email"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label class="text-black text-base" for="academic">
                                            Mother's Name
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                    <div className="xl:w-6/12">
                                        <label class="text-black text-base" for="academic">
                                            Educational Qualification
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base " htmlFor="academic">
                                            Occupation
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2 xl:px-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>

                                    <div className="xl:w-6/12">
                                        <div>
                                            <label class="text-black text-base" for="academic">
                                                Annual Income
                                                <span class="required text-red-500"> *</span>
                                            </label>
                                        </div>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                </div>

                                <div className="xl:mt-8 flex xl:w-12/12 gap-6">
                                    <div className="xl:w-6/12">
                                        <label className="text-black text-base " htmlFor="academic">
                                            Contact Number
                                            <span className="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2 xl:px-2"
                                            type="number"
                                            required />
                                    </div>

                                    <div className="xl:w-6/12">
                                        <div>
                                            <label class="text-black text-base" for="academic">
                                                Email Id
                                                <span class="required text-red-500"> *</span>
                                            </label>
                                        </div>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="email"
                                            required />
                                    </div>
                                </div>

                            </div>
                        </>
                    }

                    {currentStep === 3 &&
                        <>
                            <div className="xl:mt-8">
                                <h1 className="text-4xl text-black  font-bold  text-center ">
                                    Additional Information
                                </h1><p className="text-base pt-2 text-blue text-center">
                                    Please fill in all the required fields (marked with *)
                                </p>

                                <div className="xl:mt-12">
                                    <div className="xl:w-12/12">
                                        <label class="text-black text-base" for="academic">
                                            How did you hear about Junior Toes?
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <Select
                                            className="xl:w-full xl:mt-2"
                                            classNamePrefix="custom-select"
                                            options={options16}
                                            placeholder=""
                                            isSearchable={true}
                                            required />
                                    </div>

                                    <div className="xl:w-12/12 xl:mt-8">
                                        <label class="text-black text-base" for="academic">
                                            What values or skills would you like your child to develop in preschool?
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>

                                    <div className="xl:w-12/12 xl:mt-8">
                                        <label class="text-black text-base" for="academic">
                                            What is your biggest priority when selecting a preschool for your child?
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                    <div className="xl:w-12/12 xl:mt-8">
                                        <label class="text-black text-base" for="academic">
                                        Any Specific Concerns or Expectations for Your Child?
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <input
                                            className="w-full rounded borderform xl:mt-2"
                                            type="text"
                                            id="text"
                                            required />
                                    </div>
                                    <div className="xl:w-12/12 xl:mt-8">
                                        <label class="text-black text-base" for="academic">
                                        Would you like a school tour or discussion with the counselor?
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <Select
                                            className="xl:w-full xl:mt-2"
                                            classNamePrefix="custom-select"
                                            options={options15}
                                            placeholder=""
                                            isSearchable={true}
                                            required />
                                    </div>
                                    <div className="xl:w-12/12 xl:mt-8">
                                        <label class="text-black text-base" for="academic">
                                        Additional Comments or Questions:
                                            <span class="required text-red-500"> *</span>
                                        </label>
                                        <textarea
                                            className="w-full rounded borderform xl:mt-2"
                                            style={{height:'100px'}}
                                            required />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    <div className="flex justify-end gap-4 mt-4">
                        {currentStep > 1 && (
                            <button
                                onClick={handleBack}
                                className="xl:mt-8 xl:w-2/12 xl:py-2 border-0 focus:outline-none text-white text-center rounded"
                                style={{ background: '#F8B4A9' }}
                            >
                                Back
                            </button>
                        )}

                        {currentStep < 3 ? (
                            <button
                                onClick={handleNext}
                                className="xl:mt-8 xl:w-2/12 xl:py-2 border-0 focus:outline-none text-white text-center rounded"
                                style={{ background: '#6BB4B4' }}
                            >
                                Next
                            </button>
                        ) : (
                            <button
                                onClick={handleSubmit}
                                className="xl:mt-8 xl:w-2/12 xl:py-2 border-0 focus:outline-none text-white text-center rounded"
                                style={{ background: '#0189A5' }}
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </div>
            </section>
            <Footer2 />
        </>
    );
}
